export const ADD_FETCHING = 'ADD_FETCHING';
export const REMOVE_FETCHING = 'REMOVE_FETCHING';

// export const NEW_PROJECT_FETCHING = 'NEW_PROJECT_FETCHING ';

export const NEW_BRAINSTORM_FETCHING = 'NEW_BRAINSTORM_FETCHING ';
